

pickerBreadcrumbController = ($scope) ->
    'ngInject'

    stop = @tagPicker.tree.onNodeChange (node) =>
        @atRoot = node.isRoot
        @nodes = node.getBreadcrumb()[-2..]
        return

    $scope.$on('$destroy', stop)
    return


pickerBreadcrumbDirective = ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'util/tags/pickerBreadcrumb'
    controller: pickerBreadcrumbController
    controllerAs: 'ctrl'
    bindToController: true
    scope: tagPicker: '='


module.directive 'dybTagPickerBreadcrumb', pickerBreadcrumbDirective